import { useEffect } from "react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { Seo } from "../components/Seo";
import { PageHeader } from "../components/PageHeader";
import { Contact } from "../components/Contact";
import { buildWebPage } from "../components/schema";

export default function ContattiPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div data-testid="contatti-page">
      <Seo
        title="Contatti VETRO DESIGN ITALIA | Installazione VEPA Marche"
        description="Contatta VETRO DESIGN ITALIA per l'installazione di vetrate panoramiche VEPA nelle Marche. Preventivo gratuito ad Ancona, Osimo, Macerata, Pesaro e Senigallia."
        path="/contatti-vetrate-panoramiche"
        jsonLd={buildWebPage("Contatti · VETRO DESIGN ITALIA", "/contatti-vetrate-panoramiche", "Contatta VETRO DESIGN ITALIA per l'installazione di vetrate panoramiche VEPA nelle Marche. Preventivo gratuito.", "Contatti")}
      />
      <Navbar />
      <PageHeader
        eyebrow="Contatti"
        h1="Richiedi una consulenza per la tua vetrata panoramica"
        intro="Raccontaci il tuo progetto: un nostro tecnico ti contatterà per un sopralluogo e un preventivo gratuito. Installazione VEPA in tutta la regione Marche."
      />
      <Contact />
      <Footer />
    </div>
  );
}
